import { render, staticRenderFns } from "./UpdateEmail.vue?vue&type=template&id=524b0d8d&"
import script from "./UpdateEmail.vue?vue&type=script&lang=js&"
export * from "./UpdateEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports